import { AuthServiceConfig, FacebookLoginProvider, GoogleLoginProvider } from 'angularx-social-login';

export const SocialLoginFactory = (environment) => () => {
    return new AuthServiceConfig([
        {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider((environment.socialAuth.google || {}).clientId),
        },
        {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider((environment.socialAuth.facebook || {}).clientId),
        },
    ]);
};
